import React from 'react';

import './style.scss';

const subcomponents = [
  {
    route: '/admin/added-elections',
    title: 'User-Added Elections',
  },
  {
    route: '/admin/added-races',
    title: 'User-Added Races',
  },
  {
    route: '/admin/added-candidates',
    title: 'User-Added Candidates',
  },
  {
    route: '/admin/flagged-links',
    title: 'Flagged Links',
  },
  {
    route: '/admin/flagged-topics',
    title: 'Flagged Topics',
  },
  {
    route: '/admin/national-topics',
    title: 'National Topics',
  },
];

const Admin = (props) => {
  const {
    history,
  } = props;

  return (
    <div id="admin-content">
      <h1>Admin Portal</h1>
      <p>Click a subpage below to make changes.</p>
      <div id="sub-pages-container" className="admin-container">
        {subcomponents.map(({ route, title }) => (
          <button type="button" className="subcomponent-container" onClick={() => history.push(route)}>
            {title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Admin;
